import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ChevronRight, Clock } from "lucide-react";

function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function StoricoPage({ onLoad }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api
      .get("/analyses")
      .then((r) => setItems(r.data))
      .catch(() => {
        toast.error("Errore caricamento storico");
        setItems([]);
      });
  }, []);

  return (
    <div className="fade-up max-w-xl mx-auto space-y-8">
      <h1 className="font-heading font-bold text-2xl sm:text-3xl text-[#E3BC55] uppercase tracking-[0.18em] text-center">
        Storico Analisi
      </h1>

      {items === null ? (
        <div className="flex items-center justify-center gap-2 text-[#E3BC55]/70 font-mono-data text-sm py-16">
          <Loader2 className="w-4 h-4 animate-spin" /> CARICAMENTO…
        </div>
      ) : items.length === 0 ? (
        <p className="text-center text-slate-500 py-16">Nessuna analisi salvata. Elabora il tuo primo match dalla Fase Calcolo.</p>
      ) : (
        <div data-testid="storico-list" className="space-y-3">
          {items.map((a, i) => (
            <button
              key={a.id || i}
              data-testid={`storico-item-${i}`}
              onClick={() => onLoad(a)}
              className="w-full border-2 border-[#E3BC55]/50 hover:border-[#E3BC55] rounded-2xl bg-black px-5 py-4 flex items-center justify-between transition-colors text-left"
            >
              <div>
                <p className="text-[#E3BC55] font-semibold text-xs uppercase tracking-wider">{a.match.league}</p>
                <p className="text-white font-heading font-bold text-lg mt-0.5">
                  {a.match.home_team} <span className="text-[#E3BC55] text-sm">vs</span> {a.match.away_team}
                </p>
                <p className="text-slate-500 font-mono-data text-[11px] mt-1 flex items-center gap-1">
                  <Clock className="w-3 h-3" /> {fmtDate(a.created_at)}
                  <span className="ml-2">1: {a.riepilogo.blended_1x2["1"]}% · X: {a.riepilogo.blended_1x2["X"]}% · 2: {a.riepilogo.blended_1x2["2"]}%</span>
                </p>
              </div>
              <ChevronRight className="w-5 h-5 text-[#E3BC55] shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
